// 取件二维码
<template>
  <div class="pickupQRcode">
    <p class="text">请使用微信扫描下方的二维码进行取件</p>
      <span
        class="text"
        v-show="QRurl === ''">二维码获取中...</span>
        <img
          :src="QRurl"
          v-show="QRurl !== ''" />
  </div>
</template>

<script>
import {
  // getWeiXinTimeStampQRcode
  // showToast,
  // showLoading,
  // hideLoading
} from '../../../static/mailBox/js/request.js'
// import {
//   closeSocket
// } from '../../../static/mailBox/js/socket.js'

export default {
  name: 'mailBoxPickupQRcode',
  data () {
    return {
      QRurl: '',
      getQRcodeInterval: {}
    }
  },
  created () {
    // closeSocket()
    let vm = this
    vm.getQRurl()
    // 每隔5秒更新一次取件二维码(备注：在setInterval中使用aysnc await语法，部分浏览器会报unexpected token function(建议使用.then()))
    vm.getQRcodeInterval = setInterval(function () {
      console.log('更新')
      vm.getQRurl()
    }, 5000)
  },
  mounted () {
  },
  methods: {
    // 获取取件二维码
    getQRurl: function () {
      let vm = this
      getWeiXinTimeStampQRcode().then(function (res) {
        if (res.meta.code === 200) {
          vm.QRurl = res.body.QR_url + '?t=' + Math.random()
        } else {
          vm.QRurl = ''
        }
      })
    }
  },
  watch: {
    'QRurl': function (newVal) {
      console.log('newVal', newVal)
    }
  }
}
</script>

<style scoped>
  .pickupQRcode{
    width: 100%;
    color: #ffffff;
    text-align: center;
    height: 5rem;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .pickupQRcode .code-wrapper{
  }

  .pickupQRcode .text{
    font-size: 0.34rem
  }

  .pickupQRcode img{
    margin-top: 0.5rem;
    width: 4rem;
    height: 4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/mailBox/pickupQRcode.vue